import { workbenchServiceDict } from '@/dictionary/system'
const applicablePlatform = workbenchServiceDict.array.map(dict => dict.value)

export default [
  {
    path: '/',
    name: 'Homepage',

    component: () => import('@/views/home/new-home'),
    meta: {
      layout: 'DefaultLayout',
      hidden: true,
      applicablePlatform,
      id: 'local-0'
    }
  },
  {
    path: '/blank-page',
    name: 'BlankPage',
    component: () => import('@/views/common-views/blank-page/index'),
    meta: { layout: 'NoLayout', hidden: true }
  },
  // TODO: 只有管理员可以访问
  {
    path: '/home/enterprise-certificate/:edit?',
    name: 'HomeEnterpriseCertificate',
    component: () => import('@/views/enterprise-views/certificate/process'),
    meta: {
      layout: 'NavBarLayout',
      title: '企业信息认证',
      hidden: true
    }
  },
  {
    path: '/select-company',
    name: 'SelectCompany',
    component: () => import('@/views/common-views/select-company/index'),
    meta: {
      title: '企业选择',
      layout: 'NoLayout',
      hidden: true
    }
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('@/views/common-views/notice'),
    meta: { title: '消息通知', layout: 'NavBarLayout', hidden: true }
  },
  {
    path: '/download-management',
    name: 'DownloadManagement',
    component: () => import('@/views/common-views/file/download-management'),
    meta: { title: '下载管理', layout: 'NavBarLayout', hidden: true }
  },

  // 待办事项
  {
    path: '/to-do-list/audit/list',
    name: 'ToDoListAudit',
    component: () => import('@/views/common-views/to-do-list/audit/list'),
    meta: { title: '待办事项', layout: 'NavBarLayout', cache: true }
  },
  {
    path:
      '/to-do-list/workflow/:workflowId/task/:taskId?/initiate/:identity?/detail',
    name: 'ToDoListAuditDetail',
    component: () =>
      import('@/views/common-views/to-do-list/audit/audit-detail'),
    meta: { title: '待办详情', layout: 'NavBarLayout' }
  },
  {
    path: '/document/jxic',
    name: 'JxicDocument',
    component: () => import('@/views/common-views/document/jxic.vue'),
    meta: { title: '文档资料', layout: 'NavBarLayout' }
  },

  {
    path: '/hall/file/preview',
    name: 'FilePreview',
    component: () => import('@/views/hall/file-preview.vue'),
    meta: { title: '文件预览' }
  },

  {
    path: '/data/screen',
    name: 'GlobalDataScreen',
    component: () =>
      import('@/views/project-views/query-statistics/data-screen.vue'),
    meta: { title: '省投大屏', layout: 'NavBarLayout' }
  },

  {
    path: '/monitor/statistic/supplier-analysis/detail',
    name: 'SupplierAnalysisDetail',
    component: () =>
      import(
        '@/views/project-views/query-statistics/supplier-analysis-detail.vue'
      ),
    meta: { title: '供应商分析详情', layout: 'NavBarLayout' }
  },

  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/common-views/error-page/404'),
    meta: { hidden: true, layout: 'NavBarLayout' }
  },
  {
    path: '/401',
    name: 'NotRight',
    component: () => import('@/views/common-views/error-page/401'),
    meta: { hidden: true, layout: 'NavBarLayout' }
  }
]
